/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { func } from 'prop-types';
import withAsyncScript from '../../../../../../../../../../lib/scriptLoader';

import {
    googlePayPluginConfig,
} from '../../../../../../../../../../state/ducks/MfeCheckout/ducks/Payment/PaymentMethods/GooglePay/GooglePay-Helper';

const LoadGooglePay = (props) => {
    const { isScriptLoaded, isScriptLoadSucceed, render } = props;
    return (
        render({
            isScriptLoaded,
            isScriptLoadSucceed,
        })
    );
};

LoadGooglePay.propTypes = {
    render: func.isRequired,
};

export default withAsyncScript(googlePayPluginConfig.sdkURL)(LoadGooglePay);
